import React, { useState } from 'react';
import SweetAlert from '../../../lib/react-bootstrap-sweetalert/src';
import { useTranslation } from 'react-i18next';

const Alert = ({
  isOpen,
  mainIcon,
  title,
  onConfirm,
  onCancel,
  confirmBtnLabel,
  cancelBtnLabel,
  disabledBtn,
  children,
}) => {
  const { t } = useTranslation();

  return isOpen ? (
    <SweetAlert
      custom
      showCancel
      customIcon={mainIcon || ''}
      title={title}
      onConfirm={onConfirm}
      onCancel={onCancel}
      closeOnClickOutside={false}
      customButtons={
        <>
          {onCancel && (
            <button
              type="button"
              className="btn btn-danger w-md waves-effect waves-light"
              style={{ marginRight: '10px' }}
              disabled={!!disabledBtn}
              onClick={onCancel}>
              {t('Cancel')}
            </button>
          )}
          {onConfirm && (
            <button
              type="button"
              className="btn btn-primary w-xs waves-effect waves-light"
              onClick={onConfirm}
              disabled={!!disabledBtn}>
              {t(confirmBtnLabel)}
            </button>
          )}
        </>
      }>
      {children || ''}
    </SweetAlert>
  ) : (
    <></>
  );
};

export default Alert;
